import { frontendURL } from '../../../helper/URLHelper';
import { TASK_VIEW_PERMISSIONS } from 'dashboard/constants/permissions.js';

const MyTasks = () => import('./MyTasks.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/my_tasks'),
    name: 'my_tasks',
    component: MyTasks,
    meta: {
      permissions: ['administrator', 'agent', TASK_VIEW_PERMISSIONS],
    },
  },
];
